<ng-container *transloco="let t; read: 'gestioneSchedaControlloPulizie.strumentoRegistrazione'">
  <form [formGroup]="form" (ngSubmit)="submit(form)">
    <div fxLayout="row" fxLayoutGap="1em">
      <mat-form-field appearance="outline">
        <mat-label>{{t('data')}}</mat-label>
        <input matInput [matDatepicker]="dataInizioOsservazionePicker" formControlName="data">
        <mat-datepicker-toggle matSuffix [for]="dataInizioOsservazionePicker"></mat-datepicker-toggle>
        <mat-datepicker #dataInizioOsservazionePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{t('ora')}}</mat-label>
        <input matInput type="time" formControlName="ora">
      </mat-form-field>
    </div>

    <div class="mat-elevation-z1">
      <table mat-table [dataSource]="formListaControlliControlsTable" formArrayName="listaControlli">
        <!-- Descrizione controllo -->
        <ng-container matColumnDef="descrizioneControllo">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.descrizioneControllo')}}</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <span [ngClass]="{'category': isCategorySeparator(i)}">{{ t('table.controlli.' + element?.value?.descrizioneControllo) }}</span>
          </td>
        </ng-container>

        <!-- Conforme -->
        <ng-container matColumnDef="conforme">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.conforme')}}</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
            <mat-checkbox formControlName="conforme" *ngIf="!isCategorySeparator(i)"></mat-checkbox>
          </td>
        </ng-container>

        <!-- Osservazioni -->
        <ng-container matColumnDef="osservazioni">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.osservazioni')}}</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
            <mat-form-field *ngIf="!isCategorySeparator(i)" style="width: 100%;">
              <textarea matInput formControlName="osservazioni"></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="listaControlliDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: listaControlliDisplayedColumns when: isCategorySeparator" style="background-color: #D8CFE3;"></tr>
        <tr mat-row *matRowDef="let row; columns: listaControlliDisplayedColumns when: !isCategorySeparator"></tr>
      </table>
    </div>

    <div style="margin-top: 22px; margin-bottom: 24px; font-weight: bold; font-size: 24px;">{{t('gestione_non_conformita')}}</div>
    <div class="mat-elevation-z1">
      <table mat-table [dataSource]="formListaNonConformitaControlsTable" formArrayName="listaControlli">

        <!-- N Rif. -->
        <ng-container matColumnDef="rif">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.rif')}}</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i + listaControlliValorizzatiLength">
            <mat-form-field >
              <textarea matInput formControlName="rif" formControlName="rif"></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Provvedimento -->
        <ng-container matColumnDef="provvedimento">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.provvedimento')}}</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i + listaControlliValorizzatiLength">
            <mat-form-field style="width: 80%;">
              <textarea matInput formControlName="provvedimento"></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Data provvedimento -->
        <ng-container matColumnDef="dataProvvedimento">
          <th mat-header-cell *matHeaderCellDef>{{t('table.column.dataProvvedimento')}}</th>
          <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i + listaControlliValorizzatiLength">
            <mat-form-field >
              <input matInput [matDatepicker]="dataInizioOsservazionePicker" formControlName="dataProvvedimento">
              <mat-datepicker-toggle matSuffix [for]="dataInizioOsservazionePicker"></mat-datepicker-toggle>
              <mat-datepicker #dataInizioOsservazionePicker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="listaNonConformitaDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: listaNonConformitaDisplayedColumns"></tr>
      </table>
    </div>
  </form>
</ng-container>
